{
  "id": "atlas",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Atlas",
    "en": "Atlas"
  },
  "icon": "gods/atlas",
  "portrait": "gods/atlas-portrait",
  "age": "mythic",
  "freeUnitsOnAgeUp": {
    "argus": 1
  },
  "unlocks": ["argus", "guardian-of-io", "devotees-of-atlas", "titan-shield"],
  "powers": ["implode"],
  "meta": {
    "source": "Game files 19.17020 (techtree.xml MythicAgeAtlas)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Age-up tech: CreateUnit 1 argus at the Temple (Kronos: +1 from KronosExtra*, so 2). God power Implode (cooldown 180 s)."
  }
}
